export default "__VITE_ASSET__fHEzhATF__"